import {  sendApi } from ".";
import { T_Param } from "../model/paramModle";

async function paramList(data?: any) {
    const response = await sendApi({
      method: "post",
      url: "/param/list",
      data: {
        ...data,
      },
    });
    return response;
  }

async function paramCreate(data1?:T_Param){

  const response = await sendApi({
    method: "post",
    url: "/param/insert",
    data: {
      ...data1,
    },
  });

  
  return response;
} 

async function paramUpdate(data1?:T_Param){

  const response = await sendApi({
    method: "post",
    url: "/param/update",
    data: {
      ...data1,
    },
  });

  
  return response;
}  


async function paramDelete(data1?:T_Param){

  const response = await sendApi({
    method: "post",
    url: "/param/delete",
    data: {
      ...data1,
    },
  });

  return response;
}  


const trouble = {
    paramList,
    paramCreate,
    paramUpdate,
    paramDelete,
  };
  export default trouble;

